import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IncreaseBudgetAmountDialogContext } from './increase-budget-amount-dialog.type';

@Component({
  selector: 'increase-budget-amount-dialog',
  templateUrl: './increase-budget-amount-dialog.component.html',
  styleUrls: ['./increase-budget-amount-dialog.component.scss']
})
export class IncreaseBudgetAmountDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public readonly context: IncreaseBudgetAmountDialogContext) { }

}
